var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTimelineWaiting = function SvgTimelineWaiting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    fill: "none",
    viewBox: "0 0 14 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.76 1.2a.53.53 0 0 1 .48 0l5.776 2.976c.174.09.284.27.284.467v5.6c0 .196-.11.376-.284.466L7.24 13.684a.53.53 0 0 1-.481 0L.985 10.71a.53.53 0 0 1-.285-.466v-5.6c0-.197.11-.377.285-.467zM1.75 5.48v4.442l4.725 2.435V7.77zm5.775 2.291v4.586l4.725-2.435V5.481zm4.076-3.143-1.754.85L5.23 3.17 7 2.258zm-7.528-.862L2.4 4.628 7 6.86l1.655-.802z",
    clipRule: "evenodd"
  })));
};
export default SvgTimelineWaiting;